// extracted by mini-css-extract-plugin
export default {"submit__btn":"Button_submit__btn__hWREZ"};